module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/august/mainvisual-present@2x_3cb01662d1ac7d96e63984c60fd9726a.png";